import script from "./ErrorView.vue?vue&type=script&setup=true&lang=js"
export * from "./ErrorView.vue?vue&type=script&setup=true&lang=js"

import "./ErrorView.vue?vue&type=style&index=0&id=d399a4cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d399a4cc"]])

export default __exports__